import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import _ from "lodash";
import LogoINM from "../../assets/images/fobam_logo.svg";

export default class Navigation extends Component{
	render(){
		let { isFetching, items, location, show } = this.props;
		return(
			isFetching ?
				<div className="app-navigation loading">
					<div className="animated-background">
						<div className="background-masker"></div>
						<div className="background-masker"></div>
						<div className="background-masker"></div>
						<div className="background-masker"></div>
						<div className="background-masker"></div>
						<div className="background-masker"></div>
						<div className="background-masker"></div>
						<div className="background-masker"></div>
						<div className="background-masker"></div>
					</div>
				</div>
				: <aside className={`main-nav ${show ? '' : 'closed'}`} key="main-website-nav">
					<div className="app-logo">
						<img src={LogoINM} alt="InMujeres" className="app-logo--image" />
						<span className="app-logo--text">INM</span>
					</div>
					<ul className="app-navigation" role="navigation">
					{_.map(items, (row, k) => {
						let selected = (_.find(row, (o) => (o === location.pathname) ? true : false)) !== undefined ? 'selected' : '';
						let g = row.menu;
						let group = _.isObject((g ? _.find(g, (o) => {return location.pathname.indexOf(o.url) !== -1 }): '')) ? 'active' : '';
						return (
							row.menu ?
								<li key={k} className={row.menu ? `group ${group}${this.state.selected === row.id ? 'active' : ''}` : group} onClick={() => this.selectGroup(row.id)}>
									<span className="group--title">
										<i className={`fa fa-${!_.isEmpty(row.icon) ? row.icon : 'sliders'}`} />
										{row.name}
										</span>
									<ul className="app-navigation--submenu">
										{row.menu.map((sub, j) => {
											let url = this._setNavUrl(sub.url);
											let regex = new RegExp(url, "g");
											let sel=(regex.test(location.pathname)) ? 'selected': '';
											return <li key={j} className={sel}>
												<NavLink to={`${url}`} activeClassName="active">
													<i className={`fa fa-${sub.icon}`} />
													{sub.name}
												</NavLink>
											</li>;
										})}
									</ul>
								</li>
							: (row.url !== null) &&
								<li key={k} className={row.menu ? 'group '+selected : selected}>
									<NavLink to={`${row.url}`} activeClassName="active">
										<i className={`fa fa-${row.icon}`} />
										{row.name}
									</NavLink>
								</li>
						)
					})}
				</ul>
			</aside>
		);
	}

	constructor(props) {
		super(props);
		this.state = {
			selected: undefined
		};
	}

	selectGroup(row) {
		return this.setState({selected:row});
	}

	_setNavUrl(url) {
		let urlArray = _.split(url, '/', 8);let urlFinal = '';
		let { agencies } = this.props;
		if(!_.isEmpty(this.props.agencies)) {
			if(!(/(notificacion)+/i).test(urlArray[1])) {
				if((/(administrativo)+/i).test(urlArray[4]) || (/(juridica)+/i).test(urlArray[4])){
					if(_.findIndex(urlArray, (o) => { return o === 'modalidad-i' || o === 'modalidad-iii'}) > -1 && !_.isEmpty(agencies[`modalidad-i`])) {
						urlArray[5] = agencies[`modalidad-i`][0].agenciable_short;
						urlFinal = _.join(urlArray, '/');
					}else if(_.findIndex(urlArray, (o) => { return o === 'modalidad-ii'}) > -1 && !_.isEmpty(agencies[`modalidad-ii`])) {
						urlArray[5] = agencies[`modalidad-ii`][0].agenciable_state_short;
						urlArray[6] = agencies[`modalidad-ii`][0].agenciable_slug;
						urlFinal = _.join(urlArray, '/');
					}else{
						urlFinal = url;
					}
				}else if((/(cdms)+/i).test(urlArray[1])){
					if(!_.isEmpty(this.props.cdms)){
						urlArray[3] = this.props.cdms[0].agenciable_state_short;
						urlArray[4] = this.props.cdms[0].agenciable_slug;
						urlFinal = _.join(urlArray, '/');
					}else {
						urlFinal = url;
					}
				}else if((/(proyectos)+/i).test(urlArray[1])){
					urlFinal = url;
				}else {
					if(_.findIndex(urlArray, (o) => { return o === 'modalidad-i'}) > -1 && !_.isEmpty(agencies[`modalidad-i`])) {
						urlArray[4] = agencies[`modalidad-i`][0].agenciable_short;;
						urlFinal = _.join(urlArray, '/');
					}else if(_.findIndex(urlArray, (o) => { return o === 'modalidad-ii'}) > -1 && !_.isEmpty(agencies[`modalidad-ii`])) {
						urlArray[4] = agencies[`modalidad-ii`][0].agenciable_state_short;
						urlArray[5] = agencies[`modalidad-ii`][0].agenciable_slug;
						urlFinal = _.join(urlArray, '/');
					}else if(_.findIndex(urlArray, (o) => { return o === 'modalidad-i' || o === 'modalidad-iii'}) > -1 && !_.isEmpty(agencies[`modalidad-i`])) {
						urlArray[4] = agencies[`modalidad-i`][0].agenciable_short;
						urlFinal = _.join(urlArray, '/');
					} else{
						urlFinal = url;
					}
				}
			}else{
				urlFinal = url;
			}

		}else{
			urlFinal = url;
		}
		return urlFinal;
	}
}



// WEBPACK FOOTER //
// ./src/elements/navigation/navigation.jsx